// PetalsMining.tsx - Petals GPU Mining Dashboard
// Tek satir komut ile GPU mining baslat, FLZ kazan

import { Copy, Cpu, DollarSign, HardDrive, Shield, Zap } from 'lucide-react'
import { useState } from 'react'
import Sidebar from '../components/layout/Sidebar'
import Topbar from '../components/layout/Topbar'

export default function PetalsMining() {
  const [copied, setCopied] = useState(false)

  // Installation command (tek satir)
  const installCommand = 'curl -fsSL https://runai.live/install-petals.sh | bash'

  // Copy to clipboard
  const handleCopy = () => {
    void navigator.clipboard.writeText(installCommand)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--body-bg)' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Topbar />
        <div style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Hero Section */}
            <div style={{ marginBottom: '30px' }}>
              <h1 style={{ fontSize: '32px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '10px' }}>
                Petals GPU Mining
              </h1>
              <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>
                GPU&apos;nuzu paylasin, FLZ kazanin. Telegram gibi basit, tek satir komut.
              </p>
            </div>

            {/* Installation Card */}
            <div className="card" style={{ marginBottom: '30px', padding: '30px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '20px' }}>
                Kurulum (Tek Satir)
              </h2>

              <div style={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-default)',
                borderRadius: '8px',
                padding: '20px',
                marginBottom: '20px',
                position: 'relative'
              }}>
                <code style={{
                  fontFamily: "'DM Mono', monospace",
                  fontSize: '14px',
                  color: 'var(--text-primary)',
                  wordBreak: 'break-all'
                }}>
                  {installCommand}
                </code>

                <button
                  onClick={handleCopy}
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    padding: '8px 16px',
                    background: copied ? 'var(--success-color)' : 'var(--primary-color)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '13px',
                    fontWeight: 500
                  }}
                >
                  <Copy size={14} />
                  {copied ? 'Kopyalandi!' : 'Kopyala'}
                </button>
              </div>

              <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '10px' }}>
                Bu komut:
              </p>
              <ul style={{ fontSize: '14px', color: 'var(--text-secondary)', paddingLeft: '20px' }}>
                <li>GPU driver&apos;inizi algilar</li>
                <li>Python + Petals library kurar</li>
                <li>Otomatik olarak mining baslatir</li>
                <li>FLZ kazanclarinizi hesaplar</li>
              </ul>
            </div>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
              {/* GPU Card */}
              <div className="card" style={{ padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    background: 'rgba(59, 130, 246, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Cpu size={20} style={{ color: '#3b82f6' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>GPU</div>
                    <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-primary)' }}>
                      RTX 4090
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  24GB VRAM • 12 Layers
                </div>
              </div>

              {/* Uptime Card */}
              <div className="card" style={{ padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    background: 'rgba(16, 185, 129, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Zap size={20} style={{ color: '#10b981' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>Uptime</div>
                    <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-primary)' }}>
                      98.5%
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  +20% Quality Bonus
                </div>
              </div>

              {/* FLZ Earned Card */}
              <div className="card" style={{ padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    background: 'rgba(251, 191, 36, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <DollarSign size={20} style={{ color: '#fbbf24' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>FLZ Kazanc</div>
                    <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-primary)' }}>
                      1,440
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  Bu ay • ~60 FLZ/gun
                </div>
              </div>

              {/* Model Card */}
              <div className="card" style={{ padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    background: 'rgba(139, 92, 246, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <HardDrive size={20} style={{ color: '#8b5cf6' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>Model</div>
                    <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-primary)' }}>
                      BLOOM-176B
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  Aktif • 1,234 requests
                </div>
              </div>
            </div>

            {/* Security Guarantees */}
            <div className="card" style={{ padding: '30px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Shield size={24} style={{ color: 'var(--success-color)' }} />
                Guvenlik Garantileri
              </h2>

              <div style={{ display: 'grid', gap: '15px' }}>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <div style={{ color: 'var(--success-color)', fontSize: '18px' }}>✓</div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-primary)', marginBottom: '4px' }}>
                      Dosyalariniza erisim YOK
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                      Sadece model parametreleri GPU&apos;da calisir, hic bir dosyaniz okunmaz.
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px' }}>
                  <div style={{ color: 'var(--success-color)', fontSize: '18px' }}>✓</div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-primary)', marginBottom: '4px' }}>
                      Internet erisimi SINIRLI
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                      Sadece Petals agina baglanir, baska hic bir siteye erisim yoktur.
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px' }}>
                  <div style={{ color: 'var(--success-color)', fontSize: '18px' }}>✓</div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-primary)', marginBottom: '4px' }}>
                      Acik kaynak
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                      Tum kod GitHub&apos;da acik, istediginiz zaman inceleyebilirsiniz.
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px' }}>
                  <div style={{ color: 'var(--success-color)', fontSize: '18px' }}>✓</div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-primary)', marginBottom: '4px' }}>
                      Istediginiz zaman durdurabilirsiniz
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                      Tek komut ile mining&apos;i durdurabilir, FLZ&apos;lerinizi cekebilirsiniz.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
